module.exports = __webpack_public_path__ + "img/no hay productos iocn.ef03d4df.svg";